<template>
  <div
    v-loading="loading"
    class="my-card"
  >
    <!-- <div class="title">
      我的名片
    </div> -->
    <div
      v-if="hasCard"
      class="main-content"
    >
      <div class="aside">
        <card-aside
          :menu-list="menuList"
          default-active="名片"
          @on-select="onSelect"
        >
          <div class="reminder">
            <i class="el-icon-warning"></i><span class="reminder-txt">名片中的[动态]、[公司]由公司管理员统一更新、发布</span>
          </div>
        </card-aside>
      </div>
      <div class="table">
        <component :is="curPage"></component>
      </div>
    </div>
    <template v-else>
      <no-card @on-create="onCreate"></no-card>
    </template>
  </div>
</template>

<script>
import CardAside from '../components/card-aside'
import Card from './components/card'
import Product from './components/product'
import NoCard from './components/no-card'
export default {
  name: 'MyCard',
  components: { CardAside, Card, Product, NoCard },
  data () {
    return {
      // 菜单数据
      menuList: [
        {
          title: '名片小程序设置',
          list: ['名片', '产品', '分享名片']
        }
      ],
      // 当前页面
      curPage: 'Card',
      // 当前用户是否有卡片
      hasCard: false,
      // 是否正在加载
      loading: false
    }
  },
  created () {
    this.getCardInfo()
  },
  methods: {
    // 左侧导航切换
    onSelect (curPage) {
      switch (curPage) {
        case '名片':
          this.curPage = 'Card'
          break
        case '产品':
          this.curPage = 'Product'
          break
        case '分享':
          this.curPage = 'Share'
          break
        default:
          break
      }
    },
    // 获取卡信息
    async getCardInfo () {
      this.loading = true
      let res = await JINGTUIAPIS.CardApi.cardGet({ id: '' })
      this.loading = false
      if (res.success && !res.data) {
        this.hasCard = false
      } else {
        this.hasCard = true
      }
    },
    // 卡片创建完成时候
    onCreate () {
      this.getCardInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.my-card {
  height: 100%;

  .title {
    background-color: #fff;
    padding: 20px 30px;
  }

  .main-content {
    height: 100%;
    background-color: #fff;
    display: flex;
    overflow: hidden;

    .reminder {
      display: flex;
      padding: 0 13px 0;
      flex-direction: row;

      .el-icon-warning {
        color: #1890ff;
        font-size: 12px;
      }

      .reminder-txt {
        margin-left: 3px;
        color: #8c8c8c;
        font-size: 12px;
      }
    }

    .table {
      flex: 1;
      overflow: hidden;
    }
  }
  // 重置element 样式
  /deep/ .el-input {
    max-width: 320px;
  }
}
</style>
